
<div class="ImageLibrary">
  <div v-for="library in libraries" :key="library.name">
    <h3>{{ library.name }}</h3>
    <div class="ImageLibrary_Images">
      <div
        v-for="image in library.images"
        :key="image.url"
        class="ImageLibrary_ImageContainer"
      >
        <img :src="image.url" v-on:click="handleSelectImage(image)" />
      </div>
    </div>
  </div>
</div>
